























































import Vue from 'vue';
import {mapActions, mapGetters} from "vuex";

export default Vue.extend({
  name: 'App',
  computed: {
    ...mapGetters('account', {
      loggedIn: 'isLoggedIn',
    }),
  },
  methods: {
    ...mapActions('account', [
      'logout',
    ]),
    onLogout() {
      this.logout()
        .then(() => this.$router.push({ name: 'home'}));
    },
  }
});
